import { gql } from '@apollo/client'
import { useContext } from 'react'

import { ModalLock } from '../ai-offer-lock/modal-lock'
import { BoxLockContext } from '../context'
import {
  AiOfferSwitchFrequencyLock_OfferLockDataFragment,
  AiOfferSwitchFrequencyLock_ViewerFragment,
} from './__generated__/ai-offer-switch-frequency-lock.graphql'
import { AiOfferSwitchFrequencyLockContent } from './ai-offer-switch-frequency-lock-content'

export interface AiOfferSwitchFrequencyLockProps {
  offerLockData: AiOfferSwitchFrequencyLock_OfferLockDataFragment
  viewer?: AiOfferSwitchFrequencyLock_ViewerFragment | null
}

export function AiOfferSwitchFrequencyLock({
  offerLockData,
  viewer,
}: AiOfferSwitchFrequencyLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = (
    <AiOfferSwitchFrequencyLockContent viewer={viewer} offerLockData={offerLockData} />
  )

  switch (componentType) {
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

AiOfferSwitchFrequencyLock.fragments = {
  offerLockData: gql`
    fragment AiOfferSwitchFrequencyLock_offerLockData on OfferLockData {
      ...AiOfferSwitchFrequencyLockContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${AiOfferSwitchFrequencyLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment AiOfferSwitchFrequencyLock_viewer on Profile {
      ...AiOfferSwitchFrequencyLockContent_viewer
    }
    ${AiOfferSwitchFrequencyLockContent.fragments.viewer}
  `,
}
